import { handleBtnInput, setColorOnAvailability } from "../modules/productCard";
import {
  createElement,
  createProductBlockLinks,
  overrideSplitMenu,
  handleLastVisited,
  removeCommasFromMenu,
  createSeeMoreButtonSubcategory,
} from "../modules/globalFunctions";

import {
  moveInstagram,
  createMirandaSignature,
  separateFooterBottom,
  footerLinksToBottom,
  clickableFooter,
} from "../modules/footer";
import {
  handleCheckedFilters,
  addIDToDescription,
  changeTextInPagination,
  fixPaginationScroll,
  loadMoreTopProductsBtn,
  makeBackgroundImageCategoryPerex,
  subcategoriesToPerex,
  breadcrumbsToPerex,
} from "../modules/category";
import { storeList } from "../modules/storeList";
import {
  moveTabsOnDetail,
  removeTabsSwitcher,
  sizeTable,
  bannerInProduct,
} from "../modules/productDetail";
import {
  moveCartHeader,
  createCartFooter,
  makePriceTotalSeparateTd,
  freeShippingOnExtraDelivery,
  changeBtnToHeadingCheckoutBox,
  handleStepBack,
  changeTextInOrderBtn,
  createCartHeading,
  moveCouponFieldToSidebar,
  changeNameForPaymentType,
  shippingToSidebar,

  //buttonToBilling,
} from "../modules/cart";
import { storeDetailManipulation } from "../modules/storeDetail";

import { slickSlider } from "../modules/slick.min.js";
slickSlider();
import {
  moveNewsletterBeforeFooter,
  changeNewsletterHeading,
  createNewsletterPerex,
  addImgToNewsletter,
} from "../modules/newsletter";
function makeSlider(container, options = {}) {
  if (container && !$(container).hasClass("slick-initialized")) {
    $(container).slick({
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      ...options,
      responsive: options.responsive || [
        {
          breakpoint: 1224,
          settings: { slidesToShow: 3 },
        },
        {
          breakpoint: 926,
          settings: { slidesToShow: 2 },
        },
        {
          breakpoint: 767,
          settings: { slidesToShow: 2, dots: true },
        },
        {
          breakpoint: 601,
          settings: { slidesToShow: 1, dots: true },
        },
      ],
    });
  }
}
const availabilityColorToBG = (product) => {
  const availability = product.querySelector(".availability span");
  if (!availability) return;
  availability.style.backgroundColor = availability.style.color;
};

removeCommasFromMenu();
createSeeMoreButtonSubcategory();
/**
 * Handles the product card.
 * Define all functions that should be used on a single product card.
 * @param {*} product Product card element
 */
const handleProductCard = (product) => {
  // handleDetailBtn(product)
  handleBtnInput(product);
  setColorOnAvailability(product);
  // createNumericRagings(product)
  // moveFlagsAfterImage(product)
  // moveAvailabilityToPrices(product)
  // availabilityColorToBG(product)
  const name = product.querySelector(".name");
  const pIn = product.querySelector(".p-in");

  // moveAddToFavorites(product, pImage)
};

/**
 * Handles all product cards.
 * Selects all product cards and calls the handleProductCard function on each of them.
 */
const handleAllProducts = () => {
  const allProducts = document.querySelectorAll(".products-block .product");
  if (allProducts.length) {
    allProducts.forEach((product) => {
      handleProductCard(product);
    });
  }
};
handleAllProducts();
document.addEventListener("ShoptetDOMContentLoaded", handleAllProducts);

const footer = document.querySelector("footer");

moveInstagram();
clickableFooter();
const handleBrandsBanner = () => {
  const brandsBanner = document.querySelector("footer .brands-wrapper");
  if (brandsBanner) {
    const parentElement = brandsBanner.closest(".banner").parentElement;
    const brandsInner = brandsBanner.querySelector(".brands-inner");
    const bodyBanners = document.querySelector(".body-banners");
    const benefitBanner = document.querySelector(".benefitBanner");
    if (parentElement) parentElement.remove();
    if (bodyBanners) bodyBanners.appendChild(brandsBanner);
    else if (benefitBanner) benefitBanner.after(brandsBanner);
    if (brandsInner)
      $(brandsInner).slick({
        slidesToShow: 6,
        infinite: false,
        dots: true,
        responsive: [
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 4.5,
            },
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 3.5,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2.5,
              dots: true,
              arrows: false,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2.5,
              arrows: false,
            },
          },
        ],
      });
  }
};
handleBrandsBanner();
const blogSlider = () => {
  const blogInner = document.querySelector(".homepage-item-wrapper");
  if (blogInner)
    $(blogInner).slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      draggable: true,
      autoplay: true,
      autoplaySpeed: 5000,
    });
};
if (window.innerWidth < 768) {
  blogSlider();
}
const employeSlider = () => {
  const employeInner = document.querySelector(".our-employes");
  if (employeInner) {
    $(employeInner).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000,
    });
  }
};
if (window.innerWidth < 768) {
  employeSlider();
}
createMirandaSignature();
// createPaymentMethods()
separateFooterBottom();
footerLinksToBottom();
if (footer) {
  const footerContactHeadingSpan = footer.querySelector(
    ".custom-footer__contact > h4 > span"
  );
  const footerContactBox = footer.querySelector(".contact-box");
  if (
    footerContactHeadingSpan &&
    typeof kontaktNadpis !== "undefined" &&
    kontaktNadpis != ""
  ) {
    footerContactHeadingSpan.textContent = kontaktNadpis;
  }
  if (
    footerContactBox &&
    typeof kontaktText !== "undefined" &&
    kontaktText != ""
  ) {
    const contactText = createElement("p", ["contact-text"]);
    contactText.innerHTML = kontaktText;
    footerContactBox.append(contactText);
  }
  const siteName = footer.querySelector(".site-name");
  const address = footer.querySelector(".address-footer");
  if (address) {
    const closestParent = address.closest(".banner")?.parentElement;
    if (siteName && window.innerWidth > 1199) siteName.appendChild(address);
    closestParent.remove();
  }

  const customFooter = footer.querySelector(".footer-rows");
  const secondElement = customFooter.querySelector(
    ".custom-footer>div:nth-child(2)"
  );

  if (customFooter && secondElement) {
    secondElement.insertAdjacentElement("afterend", siteName);
  }
  // if (window.innerWidth > 767) {
  // 	const siteName = document.querySelector('.footer-rows > .site-name')
  // 	const customFooter = document.querySelector('.custom-footer')
  // 	if (siteName && customFooter) customFooter.prepend(siteName)
  // }
  // if (!document.querySelector('.footer-left')) {
  // 	const footerLeft = createElement('div', ['footer-left'])
  // 	const siteName = document.querySelector('.footer-rows > .site-name')
  // 	const footerRows = document.querySelector('.footer-rows')
  // 	const customContact = document.querySelector('.custom-footer__contact')
  // 	const footerIcons = document.querySelector('.footer-icons')
  // 	// const contactPlaceholder = document.querySelector('.custom-footer .contact-placeholder')
  // 	if (siteName) footerLeft.appendChild(siteName)
  // 	if (customContact) {
  // 		const contactUl = customContact.querySelector('.contact-box ul')
  // 		if (contactUl && typeof adresaVPaticce !== 'undefined' && adresaVPaticce !== null) {
  // 			const addressLi = createElement('li', [])
  // 			if (typeof odkazKAdrese !== 'undefined' && odkazKAdrese !== null) {
  // 				addressLi.innerHTML = `<span class="address"><a href=${odkazKAdrese} target="_blank"> ${adresaVPaticce}</a></span>`
  // 			} else {
  // 				addressLi.innerHTML = `<span class="address"><a> ${adresaVPaticce}</a></span>`
  // 			}
  // 			contactUl.appendChild(addressLi)
  // 		}
  // 		footerLeft.appendChild(customContact)
  // 	}
  // 	if (footerIcons) footerLeft.appendChild(footerIcons)
  // 	footerRows.prepend(footerLeft)
  // }
}

// handles banners on homepage

// NEWSLETTER
moveNewsletterBeforeFooter();
changeNewsletterHeading();
createNewsletterPerex();
addImgToNewsletter();

const moveShowroom = () => {
  const showroom = document.querySelector("footer .bottom-banners-wrapper");
  if (!showroom) return;
  else {
    const parentElement = showroom.closest(".banner").parentElement;
    parentElement.remove();
    if (dataLayer[0].shoptet.pageType === "homepage") {
      footer.before(showroom);
      showroom.classList.add("container");
    } else if (dataLayer[0].shoptet.pageType === "productDetail") {
      const tabsWrapper = document.querySelector(
        ".shp-tabs-wrapper.p-detail-tabs-wrapper"
      );
      tabsWrapper.after(showroom);
    }
  }
};
// moveShowroom()

document.addEventListener("dkLabLastVisitedProductsLoaded", handleLastVisited);

if (dataLayer[0].shoptet.pageType === "homepage") {
  createProductBlockLinks();
  const whySocialsPlaceholder = document.querySelector(
    ".why__wrapper .socials-placeholder"
  );
  const footerIcons = document.querySelector(".footer-icons");
  if (whySocialsPlaceholder && footerIcons) {
    whySocialsPlaceholder.replaceWith(footerIcons.cloneNode(true));
  }
  const whyItems = document.querySelectorAll(".why__item:not(.socials)");
  for (const item of whyItems) {
    const heading = item.querySelector("h5");
    if (heading) {
      heading.addEventListener("click", () => {
        item.classList.toggle("active");
      });
    }
  }
}

// KATEGORIE
if (dataLayer[0].shoptet.pageType === "category") {
  const addTitleToDescription = () => {
    const secondaryDesc = document.querySelector(
      ".category__secondDescription"
    );
    if (secondaryDesc) {
      const categTitle = document.querySelector(".category-title");
      if (categTitle) {
        const titleClone = createElement("h2", [], categTitle.textContent);
        secondaryDesc.prepend(titleClone);
      }
    }
  };
  addTitleToDescription();
  changeTextInPagination(
    window.language === "cs" ? "Zpět nahoru" : "Späť hore",
    window.language === "cs" ? "Načíst další" : "Načítať ďalšie"
  );

  handleCheckedFilters();
  addIDToDescription();
  loadMoreTopProductsBtn();
  makeBackgroundImageCategoryPerex();

  document.addEventListener("ShoptetDOMContentLoaded", () => {
    changeTextInPagination(
      window.language === "cs" ? "Zpět nahoru" : "Späť hore",
      window.language === "cs" ? "Načíst další" : "Načítať ďalšie"
    );
    handleCheckedFilters();
    addIDToDescription();
    loadMoreTopProductsBtn();
    makeBackgroundImageCategoryPerex();
  });
  fixPaginationScroll();
}

// PRODUCT DETAIL
if (dataLayer[0].shoptet.pageType === "productDetail") {
  moveTabsOnDetail();
  sizeTable();
  removeTabsSwitcher();
  bannerInProduct();
}

// CART
if (document.body.classList.contains("ordering-process")) {
  moveCartHeader();
  createCartFooter();
  createCartHeading(
    window.language === "cs" ? "Nákupní košík" : "Nákupný košík"
  );
  // moveExtraDeliveryToSidebar()
  changeTextInOrderBtn(
    window.language === "cs"
      ? "Pokračovat v objednávce"
      : "Pokračovať v objednávke"
  );
  let withHeading = true;
  moveCouponFieldToSidebar(withHeading);
  changeNameForPaymentType(
    window.language === "cs" ? "Způsob platby:" : "Spôsob platby:"
  );
  makePriceTotalSeparateTd();
  freeShippingOnExtraDelivery();
  // changeBtnToHeadingCheckoutBox()
  handleStepBack(window.language === "cs" ? "Zpět k nákupu" : "Späť k nákupu");
  const handleFreeRecapitulation = () => {
    setTimeout(() => {
      const recapItemPrices = document.querySelectorAll(
        ".recapitulation-single span[data-testid='recapItemPrice']"
      );
      if (recapItemPrices.length) {
        recapItemPrices.forEach((price) => {
          console.log(price.innerText);

          if (price.innerText.toUpperCase().includes("ZDARMA")) {
            price.classList.add("for-free");
          } else if (price.innerText == "0 Kč") {
            price.classList.add("for-free");
            price.innerText = "ZDARMA";
          } else {
            price.classList.remove("for-free");
          }
        });
      }
    }, 100);
  };
  handleFreeRecapitulation();
  document.addEventListener(
    "ShoptetShippingMethodUpdated",
    handleFreeRecapitulation
  );
  document.addEventListener(
    "ShoptetBillingMethodUpdated",
    handleFreeRecapitulation
  );

  document.addEventListener("ShoptetDOMCartContentLoaded", () => {
    // addTextToContactBox()
    moveCartHeader();
    createCartFooter();
    // addBgrdColorToAvailability()
    makePriceTotalSeparateTd();
    freeShippingOnExtraDelivery();
    changeBtnToHeadingCheckoutBox();
    createCartHeading(
      window.language === "cs" ? "Nákupní košík" : "Nákupný košík"
    );
    moveCouponFieldToSidebar(withHeading);
    // moveExtraDeliveryToSidebar()
    handleStepBack(
      window.language === "cs" ? "Zpět k nákupu" : "Späť k nákupu"
    );
    changeTextInOrderBtn(
      window.language === "cs"
        ? "pokračovat v objednávce"
        : "pokračovať v objednávke"
    );
  });
}
overrideSplitMenu();

function brandsSlider() {
  const brandsSliderWrapper = document.querySelector(".banner-wrapper .brands");
  if (!brandsSliderWrapper) return;
  makeSlider(brandsSliderWrapper, {
    infinite: true,
    dots: false,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 11,
    responsive: [
      { breakpoint: 1224, settings: { slidesToShow: 5 } },
      { breakpoint: 525, settings: { slidesToShow: 3.25 } },
    ],
  });
}
document.addEventListener("DOMContentLoaded", brandsSlider);
function activitySlider() {
  const activitySliderWrapper = document.querySelector(
    ".banner-wrapper .activites-wrapper"
  );
  if (!activitySliderWrapper) return;
  makeSlider(activitySliderWrapper, {
    infinite: false,
    slidesToShow: 4.25,
    dots: false,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      { breakpoint: 1439, settings: { slidesToShow: 3.5 } },
      { breakpoint: 1224, settings: { slidesToShow: 3.25 } },
      { breakpoint: 926, settings: { slidesToShow: 3.5 } },
      { breakpoint: 767, settings: { slidesToShow: 2.5 } },
    ],
  });
}

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth > 1199) {
    activitySlider();
  }
});

// LOGOS CAROUSEL
const brandsCarousel = () => {
  if (document.body.classList.contains("in-o-nas")) {
    const logosItemsWrapper = document.querySelector(".brands__list");
    if (logosItemsWrapper) {
      makeSlider(logosItemsWrapper, {
        slidesToShow: 8,
        arrows: true,
        dots: true,
      });
    }
  }
};
document.addEventListener("DOMContentLoaded", function () {
  brandsCarousel();
  storeDetailManipulation();
});
if (document.body.classList.contains("in-prodejny")) {
  storeList();
}
// Shipping to sidebar
shippingToSidebar();
document.addEventListener("ShoptetDOMCartContentLoaded", shippingToSidebar);

const appendFooterContact = () => {
  const footerContact = document.querySelector("#footer .contact-box>ul");

  let address;

  if (footerContact) {
    address = document.createElement("li");
    address.classList.add("address-footer");

    if (typeof adresaObsah !== "undefined" && adresaObsah !== "") {
      address.innerHTML = adresaObsah;
    }

    footerContact.appendChild(address);
  }
};
appendFooterContact();

const socialsFooter = () => {
  const footerIcons = document.querySelector(".footer-icons");
  if (!footerIcons) return;
  footerIcons.classList.add("container", "footer-links-icons");
  const footerIconsItems = footerIcons.querySelectorAll(".footer-icon");
  const footerIconsWrapper = document.createElement("div");
  footerIconsWrapper.classList.add("footer-icons-wrapper");
  footerIconsItems.forEach((item) => {
    footerIconsWrapper.appendChild(item);
  });
  footerIcons.appendChild(footerIconsWrapper);
  const footer = document.querySelector("#footer");
  if (footerIcons && footer) {
    footer.prepend(footerIcons);
  }
};
socialsFooter();
setTimeout(() => {
  const menuHelper = document.querySelector(".menu-helper");
  const menuHelperSpan = menuHelper.querySelector("span");
  menuHelper.style.height = "auto";
  menuHelperSpan.style.opacity = 1;
}, 600);
const appendMap = () => {
  // Data všech poboček
  const stores = [
    {
      title: "Drexiss s.r.o.",
      address: "Drexiss s.r.o., Italská 770, 28924 Milovice",
      lat: 50.227500016836984,
      lng: 14.878025698268354,
      website: "https://www.drexiss.cz/",
    },
    {
      title: "Pro malé dobrodruhy",
      address:
        "Pro malé dobrodruhy, Kostelecká 938/81, 19600 Praha 9 - Čakovice",
      lat: 50.15108635410194,
      lng: 14.510412497574173,
      website: "https://www.promaledobrodruhy.cz",
    },
    {
      title: "D-Style",
      address: "D-Style, Husova 16, 51401 Jilemnice",
      lat: 50.60946545269303,
      lng: 15.507375476038334,
      website: "https://www.facebook.com/dstylejilemnice/",
    },
    {
      title: "Tvůj PROSTOR",
      address: "Tvůj PROSTOR, Gočárova třída 1265, 50002 Hradec Králové",
      lat: 50.211986586491555,
      lng: 15.815077228836252,
      website: "https://tvujprostorvhradci.cz/",
    },
    {
      title: "Sportovní a dětská móda Jilemnice",
      address: "Sportovní a dětská móda Jilemnice, Husova 16, 51401 Jilemnice",
      lat: 50.60963140150027,
      lng: 15.50744679956206,
      website: "https://www.facebook.com/sportovni.a.detska.moda.jilemnice",
    },
    {
      title: "SRDCOFKA",
      address: "SRDCOFKA, Ruská 80, 43001 Chomutov",
      lat: 50.45985577924463,
      lng: 13.420105555672846,
      website: "https://www.facebook.com/Srdcofka-1855877981394081/",
    },
    {
      title: "Zlatá Žirafa Párty shop - obchod pro děti",
      address:
        "Zlatá Žirafa Párty shop - obchod pro děti, Ulice 5.Května 137, 33901 Klatovy",
      lat: 49.38309999095824,
      lng: 13.29636452742687,
      website: "https://www.zlatazirafa.cz/",
    },
    {
      title: "Tady u nás",
      address: "Tady u nás, Kostelní 21, 74101 Nový Jičín",
      lat: 49.59561629994871,
      lng: 18.01167024969899,
      website: "https://www.tadyunas.cz",
    },
    {
      title: "Tady u nás v Olomouci",
      address: "Tady u nás v Olomouci, Ostružnická 336/28, 77900 Olomouc",
      lat: 49.59500928001589,
      lng: 17.253364096074545,
      website: "https://www.tadyunas.cz/",
    },
    {
      title: "BeHappy",
      address: "BeHappy, Smetanovo náměstí 28, 57001 Litomyšl",
      lat: 49.8724920283544,
      lng: 16.30971085442421,
      website: "https://www.facebook.com/BeHappyLitomysl/",
    },
    {
      title: "Butik Brusinky",
      address: "Butik Brusinky, Kollárova 336, 66902 Znojmo",
      lat: 48.85395361676398,
      lng: 16.05096922646722,
      website: "https://www.facebook.com/ButikBrusinky",
    },
    {
      title: "KKboty.cz",
      address: "KKboty, Rapotín 824, 78814 Rapotín",
      lat: 49.99593310305439,
      lng: 17.010844177243023,
      website: "https://www.kkboty.cz/",
    },
    {
      title: "Obuv Bojkovice",
      address: "Obuv Bojkovice, Komenského 237, 68771 Bojkovice",
      lat: 49.03702208275682,
      lng: 17.811920658354744,
      website: "https://www.facebook.com/Obuv-Bojkovice-101118928411654/",
    },
    {
      title: "Pohodlné botky - OC SEVER",
      address:
        "Pohodlné botky - OC SEVER, Mírové náměstí 103, 400 01 Ústí nad Labem",
      lat: 50.660042118040835,
      lng: 14.04083826793902,
      website: "https://www.pohodlnebotky.cz/",
    },
    {
      title: "Bobu.cz",
      address: "Bobu.cz, Třída T.G.Masaryka 1118, 73801 Frýdek-Místek",
      lat: 49.682239671460806,
      lng: 18.3550619960809,
      website: "https://bobu.cz/",
    },
    {
      title: "Autoria",
      address: "Autoria, Karlovo náměstí 61, 67401 Třebíč",
      lat: 49.21567524392642,
      lng: 15.879408956258228,
      website:
        "https://www.google.cz/maps/place/Karlovo náměstí 61,67401 Třebíč",
    },
    {
      title: "Dětská móda a sport - IT Centrum",
      address:
        "Dětská móda a sport - IT Centrum, Krkonošská 16, 54301 Vrchlabí",
      lat: 50.62740228085506,
      lng: 15.610443885135792,
      website: "https://www.google.cz/maps/place/Krkonošská 16,54301 Vrchlabí",
    },
    {
      title: "Minilidi",
      address: "OC KASKÁDY TACHOV, Zámecká 2111, 34701 Tachov",
      lat: 49.79802013607071,
      lng: 12.632049083258199,
      website:
        "https://www.facebook.com/MiniLidi-d%C4%9Btsk%C3%A9-a-kojeneck%C3%A9-zbo%C5%BE%C3%AD-1137639559702713/",
    },
    {
      title: "FREESTYLE DANCE SHOP",
      address: "FREESTYLE DANCE SHOP, Školní 1000, 41501 Teplice",
      lat: 50.64273417203958,
      lng: 13.823809097706873,
      website: "https://www.freestyle-dance.cz/",
    },
    {
      title: "MOYO MÍSTO",
      address: "MOYO MÍSTO, Pražská 614, 294 71 Benátky nad Jizerou",
      lat: 50.28498220397457,
      lng: 14.827693367288896,
      website: "https://www.moyomisto.cz/",
    },
    {
      title: "Pink butik",
      address: "Pink butik, Růžová 297, 46001 Liberec",
      lat: 50.77039976475788,
      lng: 15.053780368876371,
      website: "https://www.pinkbutik.cz",
    },
    {
      title: "DaMa textil a spodní prádlo",
      address: "DaMa textil a spodní prádlo, Kavánova 175, 51401 Jilemnice",
      lat: 50.60887257837621,
      lng: 15.507590820455029,
      website: "https://www.facebook.com/DaMaTextilaspodnipradlo",
    },
  ];

  // Hranice ČR
  const minLat = 48.5;
  const maxLat = 51.1;
  const minLng = 12.0;
  const maxLng = 19.0;

  // Filtrace poboček v ČR
  const filteredStores = stores.filter(
    (store) =>
      store.lat >= minLat &&
      store.lat <= maxLat &&
      store.lng >= minLng &&
      store.lng <= maxLng
  );

  // Inicializace mapy
  const map = L.map("map").setView([50.1, 15.2], 7);

  // Přidání OSM dlaždic
  L.tileLayer(
    "https://cartodb-basemaps-a.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png",
    {
      attribution: "©OpenStreetMap, ©CartoDB",
      maxZoom: 20,
    }
  ).addTo(map);

  // Ikona s logem pro hlavní pobočku Drexiss
  const drexissIcon = L.icon({
    className: "custom-marker", // třída pro stylování
    iconUrl:
      "https://698129.myshoptet.com/user/documents/upload/icons/drexiss-logo-mountain.svg",
    iconSize: [60, 60], // velikost kontejneru
    iconAnchor: [25, 50], // bod ukotvení markeru
    popupAnchor: [0, -40],
  });

  // Standardní Leaflet ikona pro ostatní pobočky
  const defaultIcon = L.icon({
    iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });

  // Přidání markerů na mapu
  filteredStores.forEach((store) => {
    const isMain = store.title === "Drexiss s.r.o.";
    const marker = L.marker([store.lat, store.lng], {
      icon: isMain ? drexissIcon : defaultIcon,
    }).addTo(map);

    let popupContent = `<strong>${store.title}</strong><br>${store.address}`;
    if (store.website) {
      popupContent += `<br><a href="${store.website}" target="_blank" rel="noopener noreferrer">Web</a>`;
    }
    marker.bindPopup(popupContent);
  });
};
const mapContainer = document.querySelector("#map");

if (mapContainer) {
  appendMap();
}
